import { render, staticRenderFns } from "./SettlementButton.vue?vue&type=template&id=5964e8d1&scoped=true&"
import script from "./SettlementButton.vue?vue&type=script&lang=js&"
export * from "./SettlementButton.vue?vue&type=script&lang=js&"
import style0 from "./SettlementButton.vue?vue&type=style&index=0&id=5964e8d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5964e8d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VProgressCircular,VTooltip})
